/*
 * Cart drawer "docking" checkout.
 *
 * The checkout button is pinned in the non-scrolling drawer top region
 * (.cart-drawer__top-actions) so it stays visible while the cart body scrolls.
 * Once the order summary (#cart-summary) scrolls into view, the pinned copy is
 * hidden and the inline copy in its default position (.cart-drawer__order-actions)
 * is shown — toggled by the `summary-in-view` class on <cart-drawer>.
 *
 * Both checkout buttons submit the same #CartDrawer-FormSummary form, so no DOM
 * is moved. Visibility is measured against the fixed .cart-drawer__inner frame
 * (rather than IntersectionObserver, whose root depends on exactly which element
 * scrolls) so it works regardless of the drawer's scroll model.
 */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const body = drawer.querySelector('#CartDrawer-Body');
  const frame = drawer.querySelector('.cart-drawer__inner');
  if (!body || !frame) return;

  let scheduled = false;

  function setInView(inView) {
    drawer.classList.toggle('summary-in-view', inView);
  }

  function compute() {
    scheduled = false;

    // Only meaningful while the drawer is open and the summary exists.
    if (!drawer.classList.contains('is-visible')) return;

    const summary = body.querySelector('#cart-summary');
    if (!summary) {
      setInView(false);
      return;
    }

    const s = summary.getBoundingClientRect();
    const f = frame.getBoundingClientRect();

    // The summary is "in view" once its top edge has scrolled into the visible
    // frame (and it has not been scrolled fully past the top).
    setInView(s.top < f.bottom - 8 && s.bottom > f.top);
  }

  function update() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(compute);
  }

  // Scroll may happen on the body or any inner scroller — capture catches all.
  drawer.addEventListener('scroll', update, true);
  window.addEventListener('resize', update);

  // The open/close animation runs on .cart-drawer__inner; recompute when it ends.
  drawer.addEventListener('transitionend', update);

  // Cart updates (quantity change, discount apply) replace #CartDrawer-Body's
  // children, so recompute for the freshly rendered #cart-summary.
  new MutationObserver(update).observe(body, { childList: true, subtree: true });

  update();
})();
